import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const permissionsInitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const rolesReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.ROLE_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.ROLE_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.ROLE_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ROLES_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ROLES_READ_SUCCESS:
      return {
        ...state,
        data, // Update the state with the fetched data
        error: false,
        loading: false,
      };
    case actions.ROLES_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ROLE_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ROLE_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ROLE_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleRoleReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ROLE_SINGLE_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.ROLE_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.ROLE_SINGLE_DATA_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const rolePermissionsReducer = (state = permissionsInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.ROLE_PERMISSIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ROLE_PERMISSIONS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ROLE_PERMISSIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    
    case actions.ROLE_PERMISSIONS_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ROLE_PERMISSIONS_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ROLE_PERMISSIONS_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { rolesReducer, singleRoleReducer, rolePermissionsReducer };
